import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Routes, Route } from 'react-router-dom';
import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import { setPageTitle } from 'store/actions/header';
import { IssuesBoard } from './list';

const IssuesModule = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle([{ title: 'Issues', path: '.' }]));
  }, [dispatch]);

  return (
    <PageContentWrapper>
      <Routes>
        <Route path="/" element={<IssuesBoard />} />
      </Routes>
    </PageContentWrapper>
  );
};

export default IssuesModule;
